import { Box, Button, Heading, Icon } from '@hover/blueprint';
import { iconPlus } from '@hover/icons';
import React from 'react';

import {
  PROJECT_CARD_HEIGHT,
  PROJECT_CARD_WIDTH,
} from 'src/modules/homeownerApp/components/Projects/Menu/ProjectSelection/ProjectSelectionCard';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

type AddProjectCardProps = {
  onClick: () => void;
};

export const AddProjectCard = ({ onClick }: AddProjectCardProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  return (
    <Box
      as={Button}
      borderRadius={400}
      height={PROJECT_CARD_HEIGHT}
      label={t('customize.addToProject.newProject.newProject')}
      minW={PROJECT_CARD_WIDTH}
      onClick={onClick}
      scrollSnapAlign={{ base: 'center', tablet: 'none' }}
      scrollSnapStop="always"
      shadow={{ base: 'distance300', tablet: 'distance400' }}
      variant="ghost"
      width={PROJECT_CARD_WIDTH}
    >
      <Box alignItems="center" flexDir="column" justifyContent="center">
        <Icon icon={iconPlus} />
        <Heading textStyle="headingXs">
          {t('customize.addToProject.newProject.newProject')}
        </Heading>
      </Box>
    </Box>
  );
};
